import {CHECK_TYPES, RU_EVENT_TYPES, EN_EVENT_TYPES} from "sv-common/constants/checks";
import getLangValue from '../../utils/getLangValue';

export const CHECK_TYPES_OPTIONS = [
    Object.keys(CHECK_TYPES).map(checkType =>
        <option value={CHECK_TYPES[checkType]} key={CHECK_TYPES[checkType]}>
            {(getLangValue({ en: EN_EVENT_TYPES, ru: RU_EVENT_TYPES }) || RU_EVENT_TYPES)[CHECK_TYPES[checkType]]}
        </option>),
]